module.exports = "<div class=\"container-fluid main-container\">\r\n  <div class=\"gradient\"></div>\r\n  <div class=\"row\">    \r\n    <div class=\"col\">\r\n      <h1 class=\"page-title\">Select A Map Below To Explore.</h1>\r\n    </div>\r\n  </div>\r\n  <app-map-tile></app-map-tile>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main